module.exports = __webpack_public_path__ + "static/media/KH.ae60a7f6.svg";